module.exports = __webpack_public_path__ + "static/media/introClass.355adfc4.png";